import { useQuery } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisEnergyUseReadDTO } from '../generated/api-client';

export const useDiagnosisEnergyUseByDiagnosisId = (diagnosisId?: string) => {
  return useQuery<DiagnosisEnergyUseReadDTO[]>(
    `diagnosis-energy-use-${diagnosisId}`,
    () =>
      apiClient.search_by_diagnosis_id_diagnosis_energy_use_search_by_diagnosis_id__diagnosis_id__get(
        diagnosisId!
      ),
    { enabled: !!diagnosisId }
  );
};

